f<template>
    <div class="h-100 d-flex flex-column">
        <v-toolbar class="shadow-none" content-class="h-auto">
            <div class="d-flex align-items-center">
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_StructureStamp") }}</v-toolbar-title>
            </div>
            <v-spacer></v-spacer>
        </v-toolbar>
        
        <div class="border-top p-4">
                <p class="text-md lh-md">{{ $t("res_Msgs_StructureStampDesc") }}</p>
                <div>
                        <v-label class="mb-2">
                            {{ $t("res_ButtonText_Upload") }}
                        </v-label>
                        <div class="d-flex gap-2">
                            <v-file-input accept=".jpg,.jpeg,.png" solo v-model="uploadedStamp" prepend-icon="" @change="onUploadedStampChange"></v-file-input>
                            <v-text-field :placeholder="`${$t('res_Label_Width')}`" type="number" solo v-model="stampWidth"></v-text-field>
                            <v-text-field :placeholder="`${$t('res_Label_Height')}`" type="number" solo v-model="stampHeight"></v-text-field>
                            <v-btn color="primary" width="100" @click="onUploadedStampSave()">{{ $t("res_ButtonText_Save") }}</v-btn>
                        </div>
                </div>
                <div class="mt-6">
                    <label>{{ stampData=='#' ? $t("res_Label_NoStamp") : $t("res_Label_ChoosenStamp") }}</label>
                    <div class="mt-2">
                        <v-img max-width="250" style="object-fit: contain;" v-if="stampData!='#'" :src=stampData></v-img>
                        <v-img max-width="250" v-else src="/assets/images/icons/no_preview.svg"></v-img>
                        <v-btn color="error" class="mt-2" width="250" @click="deleteStructureStamp" v-if="stampData!='#' && isOrginalStamp">{{ $t("res_ButtonText_Delete") }}</v-btn>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import constants from '@/assets/js/constants'
import Multiselect from 'vue-multiselect'
import * as utils from '@/assets/js/common.js'
import { isEmptyObject } from 'jquery'
export default {
    name: 'StructureStamp',
    components: { Multiselect },
    data() {
        return {
            uploadedStamp: {},
            stampWidth: 150,
            stampHeight: 150,
            stampData: "#",
            isOrginalStamp: false,
            loading: false,
            utils: utils,
        };
    },
    props: {
        structure_id: Number,
    },
    methods:
    {
        async getUploadedStampName()
        {
            try
            {
                const res = await axios.get(constants.baseApiUrl + 'Admin/GetUploadedStructureStampName?structureId=' + this.structure_id);
                if (res.data != "" && res.data != null)
                {
                    var blob = new Blob([new Uint8Array(res.data.item2)], { type: 'image/png' });
                    this.uploadedStamp = new File([blob], res.data.item1, { type: 'image/png' });
                    this.stampWidth = res.data.item3;
                    this.stampHeight = res.data.item4;
                }
                else
                {
                    this.uploadedStamp = {};
                    this.stampWidth = 150;
                    this.stampHeight = 150;
                }
            }
            catch (err)
            {
                console.warn(err);
            }
        },
        createImage(file) {
            this.isOrginalStamp = false;
            const reader = new FileReader();
            reader.onload = e => {
                this.stampData = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        isFileTypeValid() {
            const file = this.uploadedStamp;
            console.log(file);
            return file && file.type.startsWith('image/');
        },
        onUploadedStampChange() {
            if(this.uploadStamp == null || this.uploadedStamp == undefined)
            {
                this.getStructureStamp();
                return;
            }
            const isFileTypeValid = this.isFileTypeValid();
            if(isFileTypeValid == false)
            {
                window.showAlert(this.$t("res_Msgs_FileMustBeImage"), "warning");
                this.uploadedStamp = {};
                return;
            }
            if (this.uploadedStamp.size == 0) {
                return;
            }
            this.createImage(this.uploadedStamp);
        },
        onUploadedStampSave() {
            if (isEmptyObject(this.uploadedStamp) || this.uploadedStamp.size <= 0) {
                window.showAlert("res_Msgs_PleaseSelectStamp", "warning");
            }
            else if (this.uploadedStamp.size > parseInt(constants.maxAttachmentSizeInByte)) {
                window.showAlert(window.translate("res_Msgs_uploadedStampizeValidation1") + constants.maxAttachmentSizeInMb + window.translate("res_Msgs_uploadedStampizeValidation2"), "warning");
            }
            else {
                this.uploadStamp(this.uploadedStamp);
            }
        },
        uploadStamp(stamp) {
            if(this.stampHeight < 0 || this.stampWidth < 0)
            {
                var message = this.stampHeight < 0 && this.stampWidth < 0 ? "StampHeight and StampWidth" : this.stampHeight < 0 ? 
                    "StampHeight" : "StampWidth"
                window.showAlert(this.$t("res_Msgs_EnterAPositiveNumber").replace('{0}',  message), 'warning');
                this.stampWidth = 150;
                this.stampHeight = 150;
            }
            else
            {
                let attachments = new FormData();
                attachments.append('structureId', this.structure_id)
                attachments.append('width', (this.stampWidth > 0 ? this.stampWidth : 150))
                attachments.append('height', (this.stampHeight > 0 ? this.stampHeight : 150)) 
                attachments.append('originalMail[0]', stamp)
                const headers2 = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')
                };
                axios.post(constants.baseApiUrl + 'Admin/UploadStamp', attachments, { headers: headers2 })
                    .then(response => {
                        if (response == undefined || response.data == null) {
                            window.showAlert('res_Msgs_ErrorOccured', 'error')
                        } else {
                            window.showAlert('res_Msgs_StampUploaded', 'success');
                            this.uploadedStamp = {};
                            this.getStructureStamp()
                        }
                    })
                    .catch(err => console.warn(err))
            }
        },
        async getStructureStamp() {
            try {
                const response = await axios.get(constants.baseApiUrl + 'Admin/GetStructureStampByStructureId?structureId=' + this.structure_id);
                if (response.data != "" && response.data != null) {
                    this.getUploadedStampName();
                    this.isOrginalStamp = true;
                    this.stampData = "data:image/png;base64," + response?.data?.image;
                }
                else
                {
                    this.stampData = "#";
                    this.uploadedStamp = {};
                    this.isOrginalStamp = false;
                }
            } catch (err) {
                console.warn(err);
            }
        },
        deleteStructureStamp() {
            window.showInformation('res_Msgs_Confirmation', window.translate("res_Msgs_DeleteStampConfirmation"), 
            () => {
                    axios.post(constants.baseApiUrl + 'Admin/DeleteStructureStampByStructureId?structureId=' + this.structure_id)
                    .then(response => {
                        if (response == undefined || response.data == false) {
                            window.showAlert('res_Msgs_ErrorOccured', 'error');
                        } else {
                            window.showAlert('res_Msgs_StampDeleted', 'success');
                            this.uploadedStamp = {};
                            this.uploadedStamp.value = {}
                            this.stampWidth = 0;
                            this.stampHeight = 0;
                            this.isOrginalStamp = false;
                            this.getStructureStamp();
                        }
                    })
                    .catch(err => {
                        console.warn(err);
                        window.showAlert('res_Msgs_ErrorOccured', 'error');
                    })
            }, () => {});
        },
    },
    mounted() {
        this.getStructureStamp();
    },
    watch:
    {
        structure_id: function () {
            this.getStructureStamp();
        }
    }
}

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
img#ItemPreview {
    width: 100px;
    margin: 0.5rem 0;

}
</style>